export function calcPercentage(totalValue: number, percentage: number) {
    return Number((totalValue * percentage).toFixed(2));
}